import { FolderLevel } from "./folderLevel";

export class FolderStructure {
    name: string;
    subFolders: Array<FolderStructure>;
    _id: string;
    parent: FolderStructure;
    realativePath: string;
    selected?: boolean;
    folderLevel: FolderLevel;
    displayImage: string;
}